import template from './cancel.html';
import controller from './cancel.controller';

let cancelComponent = {
    restrict: 'E',
    require: {
        booking: '^booking'
    },
    bindings: {
        cancel: '<'
    },
    template,
    controller,
    controllerAs: 'vm'
};

export default cancelComponent;


// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/cancel/cancel.component.js